import { Component, OnInit, ViewChild } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import * as moment from 'moment';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../../../shared';
import { NotifierService } from '../../shared/notifier/notifier.service';
import { BuyOrderService } from '../../services/buy-order.service';
import { ProviderService } from '../../services/provider.service';
import { PDFService } from '../../services/pdf.service';
import * as fileSaver from 'file-saver';

@Component({
  selector: 'app-buy-order-list',
  templateUrl: 'buy-order-list.component.html',
  styleUrls: ['buy-order-list.component.scss'],
  providers: [BuyOrderService, ProviderService, PDFService]
})
export class BuyOrderListComponent implements OnInit {
  tableSettingsBuyOrder: any = undefined;
  dataSourceBuyOrder: any = undefined;

  @ViewChild('myTable') myTable: any;


  select_wo: boolean = false;
  budgetData: any;
  tax_text = 'IGV';
  total: any = 0;
  totalFinal: any = 0;
  datosproveedor;
  buyOrderDetailData: any = [];
  priceWithTax: any = 0;
  buyOrderHeaderlData: any = [];
  buyOrderHeaderPrice: any;
  buyOrderdetalle: any = [];
  preciototal;
  filtroproveedor;
  filtronombreprovider;
  filteredOptions1 = '';
  fechainicio;
  fechafinal;
  stringmontototal;
  razonSocial='';
  nombreprovedor='';

  tableDataBuyOrder: any = {};
  listProviders: any = [];
  perPage = 10;
  settings = {
    pager: { display: true, perPage: this.perPage },
    noDataMessage: 'No hay datos que mostrar.', columns: undefined,
    actions: {
      add: false, delete: false, position: 'right', edit: false, columnTitle: 'Acciones',
      custom: [
        { name: 'editar', title: `<div class="editCustomButton">Editar</div>` },
        { name: 'eliminar', title: `<div class="editCustomButton">Eliminar</div>` }
      ]
    }
  };
  constructor(
    private route: Router,
    private buyOrderService: BuyOrderService,
    public dialog: MatDialog,
    private pdfService: PDFService,
    private providerService: ProviderService,
    private notifierService: NotifierService
  ) {
    this.providerService.listProviders().subscribe((result: any) => {
      this.listProviders = result;
    });
    this.tableDataBuyOrder = {
      columns: {
        doc_number: { title: 'Código' },
        provider_name: { title: 'Proveedor'},
        legal_name: { title: 'Razón Social'},
        created_date: { title: 'Fecha' },
        referential_concept: { title: 'Concepto referencial' },
        currency: { title: 'Moneda' },
        total: { title: 'Monto Total' },
        user_name: { title: 'Creado Por' }
      },
      data: {}
    };
  }
  ngOnInit() {
    this.tableSettingsBuyOrder = this.copyObject(this.settings);
    this.providerService.listProviders().subscribe((result) => {
      this.listProviders = result;
      this.buyOrderService.getAllBuyOrderHeaders().subscribe((result: any) => {
        this.getTableData(result);
      });
    });

  }


  getProveedor(event?) {
    if (event) {
        this.filteredOptions1 = event.target.value
    }
    this.providerService.getProviderByName(this.filteredOptions1.replace(/ /g, ""))
        .subscribe(
            result => {
                this.listProviders = result as Array<any>
                this.filtroproveedor = this.listProviders[0].id;

            },
            error => {
                console.log('error', error)
            }
        )
}

  onProviderSelected(selectedUsuario) {
    this.filtroproveedor = selectedUsuario.id;
  }

  enableBtnDownloadList = true;

  downloadTable() {
    // Si se cambia la propiedad relacionada a las columnas, los filtros van a cambiar
    this.enableBtnDownloadList = false;
    if (this.dataSourceBuyOrder) {
      const { filters } = (this.dataSourceBuyOrder as LocalDataSource).getFilter();

      console.log(filters, ' fs')

      if (filters && filters.length >= 0) {

        const code = filters.find( (f: any) => f.field === 'doc_number' && f.search !== '' );
        const provider = filters.find( (f: any) => f.field === 'provider_name' && f.search !== '' );
        const legalName = filters.find( (f: any) => f.field === 'legal_name' && f.search !== '');
        const createdDate = filters.find( (f: any) => f.field === 'created_date' && f.search !== '');
        const referentialConcept = filters.find( (f: any) => f.field === 'referential_concept' && f.search !== '');
        const createdBy  = filters.find( (f: any) => f.field === 'user_name' && f.search !== '');
        const currency = filters.find( (f: any) => f.field === 'currency' && f.search !== '' );
        const total = filters.find( (f: any) => f.field === 'total' && f.search !== '' );

        const objFilters = {
          code: code ? code.search : null, 
          provider: provider ? provider.search : null, 
          legalName: legalName ? legalName.search : null, 
          createdDate: createdDate ? createdDate.search : null, 
          referentialConcept: referentialConcept ? referentialConcept.search : null, 
          createdBy: createdBy ? createdBy.search : null,
          currency: currency ? currency.search : null,
          total: total ? total.search : null
        }

        console.log(objFilters, 'objf')

        this.notifierService.systemNotify({
          title: 'Procesando información',
          message: 'Exportando lista de Órdenes de Compra...',
          type: 'info',
        });

        this.buyOrderService.downloadBuyOrderList(objFilters)
        .subscribe( (result ) => {
          let blob = result as any;
          let fileName = `lista_ordenes_compra`;
          fileSaver.saveAs(blob, fileName);
          this.notifierService.systemNotify({
            title: 'Descarga completada',
            message: 'Lista de órdenes de compra descargada correctamente',
            type: 'success',
          });
          this.enableBtnDownloadList = true;
        }, (error) => {
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'No se ha podido descargar la lista de Órdenes de Compra',
            type: 'error'
          });
          this.enableBtnDownloadList = true;
        })
      } else {
        this.enableBtnDownloadList = true;
      }

    }else {
      this.enableBtnDownloadList = true;
    }

  }

  exportPDF(){
    /*this.notifierService.systemNotify({
      title: 'Espere un momento',
      message: 'Descargando PDF',
      type: 'info',
      duration: 20000
    });

    const tempData = {
      details: this.buyOrderdetalle,
      nomprovider: this.razonSocial,
      razonsocial: this.nombreprovedor,
      subtotal: this.totalFinal,
    }

 

    this.pdfService.getPDF(tempData, 'ocProviderPDF').subscribe(
      (result: any) => {
        const filename = 'OrdenCompra' + this.dataSourceBuyOrder.doc_number + '.pdf';
        fileSaver.saveAs(result, filename);
        this.notifierService.systemNotify({
          title: 'Exito',
          message: 'Se ha descargado el PDF.',
          type: 'success'
        });
      },
      
      error => {
        console.log(error);
        this.notifierService.systemNotify({
          title: 'Error',
          message: 'Ha ocurrido un error al descargar el PDF',
          type: 'error',
          duration: 5000
        });
      });*/

  }

  async calcularReporte() {

   /* this.notifierService.systemNotify({
      title: 'Espere un momento',
      message: 'calculando reporte',
      type: 'info',
      duration: 20000
    }); */
  
  
    if (this.fechainicio && this.fechafinal) {
      if (this.filtroproveedor){


     
      if (moment(this.fechainicio).format('YYYY-MM-DD') <= moment(this.fechafinal).format('YYYY-MM-DD')) {
        this.fechainicio = moment(this.fechainicio).format('YYYY-MM-DD');
        this.fechafinal = moment(this.fechafinal).format('YYYY-MM-DD');


        this.buyOrderHeaderPrice = 0;
        this.preciototal = 0;
         this.buyOrderService.getBuyOrderHeaderProveedor(this.filtroproveedor,this.fechainicio,this.fechafinal).subscribe((result: any) => {
          this.buyOrderHeaderlData = result;
          this.razonSocial = result[0].comercial_name;
          this.nombreprovedor = result[0].social_reason;
         this.buyOrderHeaderlData.forEach(element1 => {
        //   for  (const element1 of this.buyOrderHeaderlData) {
            this.buyOrderService.getBuyOrderDetails(element1.id).subscribe((buyOrderDetails: any) => {
              const cloneRows: Array<any> = [...buyOrderDetails];
              for (const item of cloneRows) {
                this.preciototal += Number(item.price);
              }
        
              switch (Number(element1.tax)) {
                case 1:
                  this.tax_text = 'IGV';
                  this.priceWithTax = this.preciototal * 1.18;
                  break;
                case 2:
                  this.tax_text = 'Inafecto';
                  this.priceWithTax = this.preciototal;
                  break;
                case 3:
                  this.tax_text = 'Exonerado';
                  this.priceWithTax = this.preciototal;
                  break;
                case 4:
                  this.tax_text = 'RH0';
                  this.priceWithTax = this.preciototal;
                  break;
                case 5:
                  this.tax_text = 'RH8';
                  this.priceWithTax = this.preciototal * 0.92;
                  break;
                default:
                  break;
              }
        
              this.total = Number(Number(this.priceWithTax) + Number(element1.others)).toFixed(2);
              let line = {
        
                nrodoc: element1.doc_number,
                fecha: moment(element1.created_date).format('DD/MM/YYYY'),
                usuario: element1.user_name,
                moneda: element1.money,
                monto: this.total,
        
              }
              this.buyOrderdetalle.push(line);
              this.totalFinal = 0;
              for (const item of this.buyOrderdetalle) {
                this.totalFinal = Number(Number(this.totalFinal) + Number(item.monto)).toFixed(2);
              }
              this.stringmontototal = this.totalFinal.toLocaleString();
    
              console.log(this.total);
              console.log(this.stringmontototal);
            
            })
          })
          
          let timestampDiffs = [3, 2, 4];
    
          (async () => {
            for (let item of timestampDiffs) {
              await timeout(item * 1000);
              console.log('waited: ' + item);
            }
          })();
          
          function timeout(ms) {
              return new Promise(resolve => setTimeout(resolve, ms));
          }
    
        
    
          const tempData = {
            details: this.buyOrderdetalle,
            nomprovider: this.razonSocial,
            razonsocial: this.nombreprovedor,
            subtotal: this.stringmontototal,
          }
          this.pdfService.getPDF(tempData, 'ocProviderPDF').subscribe(
            (result: any) => {
              //console.log(tempData);
              const filename = 'OrdenCompra' + this.dataSourceBuyOrder.doc_number + '.pdf';
              fileSaver.saveAs(result, filename);
              this.notifierService.systemNotify({
                title: 'Exito',
                message: 'Se ha descargado el PDF.',
                type: 'success'
              });
            },
            error => {
              console.log(error);
              this.notifierService.systemNotify({
                title: 'Error',
                message: 'Ha ocurrido un error al descargar el PDF',
                type: 'error',
                duration: 5000
              });
          });
        
      })



      } else {
        this.notifierService.systemNotify({
          title: 'Atención',
          message: 'La fecha de inicio debe ser anterior que la fecha de fin',
          type: 'warning'
        });
      }
      }else{
        this.notifierService.systemNotify({
          title: 'Atención',
          message: 'Debe indicar un proveedor',
          type: 'warning'
        });
      }
    } else {
      this.notifierService.systemNotify({
        title: 'Atención',
        message: 'Por favor complete ambas fechas (inicio y fin) para poder realizar el reporte',
        type: 'warning'
      });
    }
   
  
    }



     getTableData(result) {
    const cloneRows: Array<any> = [...result];

    for (const item of cloneRows) {
      item.created_date = moment(item.created_date).format('DD/MM/YYYY');
      const found = this.listProviders.find((element) => {
        // tslint:disable-next-line:triple-equals
        return element.id == item.id_provider;
      });
      item.provider_name = found.comercial_name
      item.legal_name = found.social_reason

    }

    this.dataSourceBuyOrder = new LocalDataSource(cloneRows);

    this.tableSettingsBuyOrder = this.copyObject(this.settings);
    if (this.tableDataBuyOrder.columns !== undefined) {
      this.tableSettingsBuyOrder.columns = this.copyObject(this.tableDataBuyOrder.columns);
      // Se deshabilita los filtros predefinidos para evitar conflictos
      Object.keys(this.tableSettingsBuyOrder.columns).forEach(key => {
        this.tableSettingsBuyOrder.columns[key].filter = true;
      });
    }

 

    if (localStorage.getItem('filter-buy-order') != '' && localStorage.getItem('filter-buy-order') ){

      var elem = JSON.parse(localStorage.getItem('filter-buy-order') );
      if (cloneRows.length > 0){
        this.dataSourceBuyOrder.setFilter(elem.filters);
        localStorage.setItem('filter-buy-order', '');
      }
      
    }




  }

  customBuyOrderAction(event) {
    switch (event.action) {
      case 'editar':
          localStorage.setItem('filter-buy-order' ,JSON.stringify(this.dataSourceBuyOrder.getFilter()));

        this.route.navigate(['/system/buy-order/edit', event.data.id]);
        break;
      case 'eliminar':
        const deleteDialog = this.dialog.open(AlertComponent, {
          data: {
            icon: 'exclamation-circle',
            iconColor: 'failure',
            title: 'Aviso',
            text: `¿Está seguro que desea eliminar la Orden de Compra?`,
            options: true
          }
        });
        deleteDialog.afterClosed().subscribe((result) => {
          if (result) {
            this.buyOrderService.deleteBuyOrderHeader(event.data.id).subscribe((deleteResult) => {
              this.notifierService.systemNotify({
                title: 'Éxito',
                message: 'Se ha eliminado el Cliente con exito',
                type: 'success'
              });
              this.ngOnInit();
            });
          }
        }, (error) => {
          console.log('error', error);
          this.notifierService.systemNotify({
            title: 'Error',
            message: 'No se ha podido eliminar la Orden de Compra',
            type: 'error'
          });
          this.ngOnInit();
        });

        break;
    }
  }

  copyObject(obj): object {
    return JSON.parse(JSON.stringify(obj));
  }
}



// WEBPACK FOOTER //
// ./src/app/system/buy-order/buy-order-list/buy-order-list.component.ts